import { connect } from 'react-redux'
import { get } from 'lodash'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import { getEmbedConfig } from 'app/modules/embed/selectors'

import NonMatchAnswerBody from './component'

const mapStateToProps = state => ({
  answer: PlaybookSelectors.getCurrentAnswer(state),
  question: PlaybookSelectors.getCurrentQuestionByAnswer(state),
  theme: get(getEmbedConfig(state), 'theme'),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSkipTo: PlaybookActions.setSkipTo,
    },
    dispatch
  ),
})

export default compose(connect(mapStateToProps, mapDispatchToProps))(NonMatchAnswerBody)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalNonMatchBody/index.js